<mat-card appearance="outlined" class="login">
  <mat-card-title>{{ 'project.title' | translate:locale.language }} - {{ 'login.title' | translate:locale.language }}</mat-card-title>
  <mat-card-subtitle>{{ 'login.subtitle' | translate:locale.language }}</mat-card-subtitle>
  <mat-card-content>
    <form [formGroup]="signinForm" (ngSubmit)="onSignin()">

      <p class="errors" *ngIf="fehler" [innerHTML]="fehler.messagehtml"></p>

      <mat-form-field>
        <input matInput formControlName="user" type="user" id="user" #user required />
        <mat-label>
          <i class="material-icons app-input-icon">person_outline</i> {{ 'login.username' | translate:locale.language }}
        </mat-label>
      </mat-form-field>

      <mat-form-field>
        <input matInput formControlName="password" type="password" id="password" #password required />
        <mat-label>
          <i class="material-icons app-input-icon">lock_outline</i> {{ 'login.password' | translate:locale.language }}
        </mat-label>
        <span matSuffix><button type="button" [disabled]="password.value==null || password.value==''" (mousedown)="showPassword($event)" (mouseup)="hidePassword($event)" (mouseout)="hidePassword($event)" mat-icon-button class="mat-24" style="height:16px; width:16px; line-height:16px;"><i class="material-icons app-input-icon show-password-icon">visibility</i></button></span>
      </mat-form-field>
      <div class="button-container">
        <button mat-raised-button color="primary" [disabled]="isButtonDisabled()">
          <i *ngIf="!isRequestRunning" class="material-icons app-input-icon">power_settings_new</i>
          <mat-spinner *ngIf="isRequestRunning" diameter="15" class="material-icons app-input-icon"></mat-spinner>
          {{ 'login.btn_login' | translate:locale.language }}
        </button>
      </div>
    </form>
    <span class="version">{{ appVersion }}</span>
  </mat-card-content>
</mat-card>

